export const POSITIVE = 'positive';
export const NEGATIVE = 'negative';
export const INFORMATION = 'information';
export const DISASTER = 'disaster';
